export function enumToArray(enumerator): any[] {
  return Object.keys(enumerator).map((x) => enumerator[x]);
}
